import { useMutation } from "react-query";
import http from "infra/http";

function useModificarArquivoAnexoMensagem(mensagemId: string) {
  return useMutation(
    ({ arquivoId, file }: { arquivoId: string; file: File }) => {
      const formData = new FormData();
      formData.append("file", file);

      return http.put(
        `/v1/mensagem/${mensagemId}/anexo/arquivo/${arquivoId}`,
        formData
      );
    },
    { retry: false }
  );
}

export default useModificarArquivoAnexoMensagem;
